<template>
  <div>
    <section class="vendor-questions container text-right p-3 mt-md-0 mt-3">
      <div class="accordion box-shadow py-sm-3" id="accordionExample2">
          <div v-for="(item , index) in data" :key="index" class="card px-sm-3" :class="{'card-border': cardBorder === index}">
            <div class="card-header text-right" :id="'heading' + index">
              <h6 class="mb-0">
                <button @click="cardBorder = index" class="btn btn-link btn-block text-right d-flex justify-content-between "  type="button" data-toggle="collapse" :data-target="'#collapse' + index" aria-expanded="false" :aria-controls="'collapse' + index">
                 <div class="d-flex align-items-baseline">
                    <span class="rounded-circle mx-sm-3 mx-2 my-auto">
                    <svg class="icon" width="25" height="25"><use href="@/assets/svgIcons/svgIcons.svg/#plus-circle"></use></svg>
                  </span>
                   <p class="mb-0 text-justify fontsize-small line-height2 weight-light">
                     {{ item.question }}
                   </p>
                 </div>

                </button>
              </h6>
            </div>

            <div :id="'collapse' + index" class="collapse" :class="{show: index === 0}" :aria-labelledby="'heading' + index" data-parent="#accordionExample2">
              <div class="card-body ">
                <p class=" line-height2 fontsize-small weight-light text-justify pr-4">
                  {{ item.answer }}
                </p>
              </div>
            </div>
          </div>
        </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "CommonQuestions",
  props:{
    data:Array
  },
  data(){
    return{
      cardBorder:0,
      

    }
  },
  components:{
  }
}
</script>

<style scoped>
/****============== Start common questions =================****/
.vendor-questions .accordion{
  border-radius: 35px;
  overflow: hidden;
  background-color: white;
}
.vendor-questions .accordion > .card , .question-tab-content .accordion > .card {
  border-top: unset !important;
  border-right: unset !important;
  border-left: unset !important;
  background-color: white !important;
  /*padding-top: .75rem;*/
  /*padding-bottom: .75rem;*/
}
.vendor-questions .accordion > .card:not(:last-child) , .question-tab-content .accordion > .card:not(:last-child){
  border-bottom: 1px solid rgba(0, 0, 0, .125) !important;
}
.vendor-questions .accordion > .card:last-child{
  border-bottom: unset !important;
}
.vendor-questions .accordion > .card , .question-tab-content  .accordion > .card {
  /*border-radius: 10px !important;*/
  /*background-color: white !important;*/
}
.vendor-questions .card-header , .question-tab-content .card-header  {
  padding: 8px !important;
  margin-bottom: 0;
  background-color: white !important;
  border-bottom: unset !important;
}
.vendor-questions .btn-link , .question-tab-content .btn-link {
  font-size: 13px !important;
  /* font-weight: 300 !important; */
  color: var(--color-666) !important;
  text-decoration: none !important;
}
.vendor-questions .btn-link:hover , .question-tab-content .btn-link:hover  {
  /* font-weight: 400; */
  color: var(--color-666) !important;
  text-decoration: none !important;
}
.vendor-questions .btn.focus, .btn:focus  , .question-tab-content .btn.focus{
  /* outline: 0; */
  box-shadow: unset !important;
}
.vendor-questions .card-body , .question-tab-content .card-body{
  /*font-size: 12px !important;*/
  color:var(--color-666) !important;
  padding-right: 2rem;
}
.vendor-questions .btn-link[aria-expanded="true"] ,
.vendor-questions .btn-link[aria-expanded="true"]:hover , .question-tab-content .btn-link[aria-expanded="true"]  ,
.question-tab-content .btn-link[aria-expanded="true"]:hover {
  color: var(--color-444) !important;
}
.vendor-questions .btn-link[aria-expanded="true"]>svg , .question-tab-content .btn-link[aria-expanded="true"]>svg  {
  transform: rotate(-180deg);
}

.vendor-questions .btn-link svg , .question-tab-content .btn-link svg  {
  transition: .6s;
  flex-shrink: 0 !important;
}
/* .vendor-questions .btn-link[aria-expanded="false"] svg , .question-tab-content .btn-link[aria-expanded="fase"] svg  {
    transform: rotate(-180deg);
} */
.vendor-questions .card-border .btn-link div svg>path , .question-tab-content .card-border  .btn-link div svg>path {
  fill: var(--color-theme) !important;
  stroke: var(--color-theme) !important;
}
.vendor-questions  .card-border .btn-link div p , .question-tab-content .card-border  .btn-link div p {
  color:var(--color-theme) !important;
}
.vendor-questions  .card-border .btn-link span , .question-tab-content .card-border  .btn-link span  {
  background-color: var(--color-themeOp) ;
  /*color: white !important;*/
}
.vendor-questions  .card-border .btn-link span svg.icon , .question-tab-content .card-border  .btn-link span svg.icon{
  transform: rotate(45deg);
}
.card-border{
  /*border: 1px solid var(--color-theme) !important;*/
  /*border-bottom:  1px solid var(--color-theme) !important;*/
}
.vendor-questions .btn-link.collapsed span{
  background-color: unset;
}
.vendor-questions .btn-link.collapsed span svg.icon{
  transform: rotate(0deg);
}
.vendor-questions  .card-border .btn-link.collapsed div p , .question-tab-content .card-border  .btn-link.collapsed div p{
  color: var(--color-666) !important;
}

.vendor-questions .accordion > .card.card-border , .question-tab-content .accordion > .card.card-border{
  /*border-bottom: 1px solid var(--color-theme) !important;*/

}
.vendor-questions .btn-link.btn{
    padding-right: 0 !important;
  }
/****============== End common questions =================****/
@media screen and (max-width: 767px){
  .vendor-questions .btn-link.btn[data-v-14ffd8a2] {
    padding-right: .75rem !important;
  }
  .vendor-questions  .btn-link span, .question-tab-content  .btn-link span {
    display: none;
  }
  .vendor-questions .card-body, .question-tab-content .card-body {
    padding-right: 1rem;
  }
}
</style>

